import React, { useEffect } from 'react'
import { BodyText, LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const VirtualDebitCard = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
                 With bonpellz virtual debit card secured by encryption.
          </h3>
          <BodyText>
                you can make contactless payment in stores and online to purchase items, it’s a safe and convenient way to pay online and in store
          </BodyText>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8614.svg" alt="couple saving in a bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}